import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "slick-carousel"

export default class extends Controller {
  connect() {
    console.log("🔥 Carousel controller connected", new Date())

    requestAnimationFrame(() => {
      if (!$(this.element).hasClass("slick-initialized")) {
        $(this.element).slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          dots: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        })
      }
    })
  }
}
